import React from 'react'
import Aboutimg from "../../images/about-image.png";
import MobileImage2 from '../../images/Change_image/imagen_nosotros.png'
import { useLanguage } from '../../Providers/LanguageContext';
import AboutBanner from './AboutBanner';

export default function Nosotros1() {

  const { language, currentLanguage } = useLanguage()
  return (

    <>
<AboutBanner/>
      <section id='about-us' style={{
        background: 'linear-gradient(rgb(15, 36, 55), rgb(255, 255, 255))',
      }}>
        <div className='top-heading d-none'>
          <div className='container-fluid'>
            <div className='row'>
              <div className="col-xl-4 col-lg-4 col-md-4 col-12"></div>
              <div className="col-xl-8 col-lg-8 col-md-12 col-12">
                <div className='heading'>
                  {/* <h2>   </h2> */}
                  <h2>{language.about_us}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='about_content'>
          <div className='container-fluid'>
            <div className='row'>
              {/* <div className='col-xl-4 col-lg-4 col-md-12 col-12'>
                <div className='about-image'>
                  <img className="img-fluid" src={MobileImage2} />
                </div>
              </div> */}
              <div className='col-xl-12 col-lg-12 col-md-12 col-12'>
                <div className='right-content'>
                  <div className='first-content' style={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'center',
                    rowGap:'20px',
                
                    
                  }}>
                    <h4 style={{
                      color:'#fff'
                    }}>{language.why}</h4>
                    <p style={{
                      background:'#fff'
                    }} >{language.about_patent}</p>
                  </div>

                  <div className='first-content'>
                    <h4 style={{
                      color:'#fff'
                    }}>{language.how}</h4>
                    <p style={{
                      background:'#fff'
                    }}>{language.about_all_this}</p>
                  </div>

                  <div className='first-content'>
                    <h4  style={{
                      color:'#fff'
                    }}> {language.what}</h4>
                    <p style={{
                      background:'#fff'
                    }}>{language.about_give_user}</p>
                  </div>
                </div>
                {/* <div className='power-by'>
                  <p>Powered by CIP</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
